export default class {
	idPedido
	numeroProcesso
	contratosVinculados
	situacao
	enderecoEntrega
	idAlmoxarifado
	numeroEmpenho

	constructor(
		idPedido,
		numeroProcesso,
		contratosVinculados,
		situacao,
		enderecoEntrega,
		idAlmoxarifado,
		numeroEmpenho,
	) {
		this.idPedido = idPedido
		this.numeroProcesso = numeroProcesso
		this.contratosVinculados = contratosVinculados
		this.situacao = situacao
		this.enderecoEntrega = enderecoEntrega
		this.idAlmoxarifado = idAlmoxarifado
		this.numeroEmpenho = numeroEmpenho
	}
}
